import { Dialog } from "primereact/dialog";
import React, { useEffect } from "react";
import "../Dialog.css";

import useAlert from "../../../hooks/useAlert";
import { useForm } from "antd/lib/form/Form";
import { Col, Form, Row, Switch } from "antd";
import { InputText } from "primereact/inputtext";
import { FiSave } from "react-icons/fi";
import { SaveCostcenter } from "../../../Services/CostCenterService";
interface Props {
  dialogHeader: string;
  formData: any;
  tableData?: any;
  setTableData?: (items: any) => void;
  tableComfirmDialog?: boolean;
  setTableComfirmDialog?: (bool: boolean) => void;
  mainDialogVisible?: boolean;
  toggleMainDialog: (state: boolean, action: string) => void;
  setMainLoading?: (bool: boolean) => void;
}

export const CostCenterDialog = (props: Props) => {
  const { toggleAlert } = useAlert();
  const [form] = useForm();

  useEffect(() => {
    form.setFieldsValue(props.formData);
  }, [props.formData]);

  const handleSubmit = async (values: any) => {
    if (props.setMainLoading !== undefined) {
      props.setMainLoading(true);
    }
    const res = await SaveCostcenter(values);
    if (res) {
      props.toggleMainDialog(false, "save");
      form.resetFields();
      toggleAlert({
        type: "success",
        message: "Success",
        description: "Cost Center saved successfully",
      });
    } else {
      toggleAlert({
        type: "error",
        message: "Error",
        description: "Cost Center not saved",
      });
    }
    if (props.setMainLoading !== undefined) {
      props.setMainLoading(false);
    }
  };

  return (
    <Dialog
      visible={props.mainDialogVisible}
      breakpoints={{}}
      style={{ width: "70vw", borderRadius: "16px" }}
      header={props.dialogHeader}
      modal
      className="p-fluid"
      onHide={() => {
        form.resetFields();
        props.toggleMainDialog(false, "close");
      }}
      draggable={false}
      closable={false}
      blockScroll
    >
      <Form form={form} name="CostCenterForm" onFinish={handleSubmit}>
        <Form.Item name="Id" hidden />
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            <Form.Item
              label="Cost Center Code"
              name="CostCenterCode"
              validateTrigger="onBlur"
              rules={[
                {
                  required: true,
                  message: "Please enter Cost Center Code",
                },
              ]}
            >
              <InputText maxLength={50} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Description" name="Description" initialValue={""}>
              <InputText maxLength={500} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between" gutter={10}>
          <Col>
            <Form.Item
              label="Is Active"
              name="IsActive"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
        <div className="footer-dialog">
          <button
            onClick={() => {
              props.toggleMainDialog(false, "close");
            }}
            className="button-cancle"
          >
            Close
          </button>

          <button className="button-save" type="submit">
            <FiSave />
            Save
          </button>
        </div>
      </Form>
    </Dialog>
  );
};
